/**
 * Maps an amenity label (case/whitespace-insensitive substring match) to the
 * most appropriate lucide-react icon. Falls back to a generic Check icon when
 * we don't have a specific match — keeps the UI honest instead of mislabelling
 * everything as Wi-Fi.
 */
import {
  Wifi,
  Tv,
  ChefHat,
  WashingMachine,
  Snowflake,
  Flame,
  Car,
  Waves,
  Dumbbell,
  ShowerHead,
  Coffee,
  Refrigerator,
  Utensils,
  WavesLadder,
  Thermometer,
  ParkingCircle,
  PawPrint,
  Cigarette,
  Baby,
  Dog,
  Shirt,
  Microwave,
  Bath,
  Bed,
  Lock,
  Shield,
  Camera,
  Trees,
  Wind,
  Sofa,
  Check,
} from 'lucide-react';

// Ordered: longer/more-specific strings first so "washing machine" beats "wash".
const AMENITY_ICONS = [
  [/\b(wi[- ]?fi|internet|wireless)\b/i, Wifi],
  [/\b(tv|television|cable|netflix|hdtv|smart\s*tv)\b/i, Tv],
  [/\b(kitchen|cook(ing)?|stove|oven)\b/i, ChefHat],
  [/\b(microwave)\b/i, Microwave],
  [/\b(fridge|refrigerator|freezer)\b/i, Refrigerator],
  [/\b(dining|dishware|utensils|cutlery|dishes)\b/i, Utensils],
  [/\b(coffee|espresso|kettle|nespresso)\b/i, Coffee],
  [/\b(washing\s*machine|washer|laundry|dryer)\b/i, WashingMachine],
  [/\b(iron|ironing)\b/i, Shirt],
  [/\b(a[ -]?c|air\s*conditioner|air\s*conditioning|central\s*air|cooling)\b/i, Snowflake],
  [/\b(heat(ing|er)?|radiator|furnace|fireplace)\b/i, Flame],
  [/\b(parking|garage|driveway|carport)\b/i, ParkingCircle],
  [/\b(free\s*parking|street\s*parking|valet)\b/i, Car],
  [/\b(pool|hot\s*tub|jacuzzi|swim)\b/i, Waves],
  [/\b(beach|waterfront|lake|ocean)\b/i, WavesLadder],
  [/\b(gym|fitness|workout|exercise)\b/i, Dumbbell],
  [/\b(shower|bathtub|bath\b)/i, ShowerHead],
  [/\b(bathroom|toilet)\b/i, Bath],
  [/\b(bed|bedding|linens|sheets|pillow)\b/i, Bed],
  [/\b(lock|keypad|smart\s*lock|doorman)\b/i, Lock],
  [/\b(safe|security|alarm)\b/i, Shield],
  [/\b(camera|cctv|surveillance)\b/i, Camera],
  [/\b(backyard|garden|patio|balcony|terrace|outdoor)\b/i, Trees],
  [/\b(dryer|ventilation|fan)\b/i, Wind],
  [/\b(hair\s*dryer|dryer\b)/i, Wind],
  [/\b(thermostat|nest)\b/i, Thermometer],
  [/\b(pet|dog)\b/i, Dog],
  [/\b(pet[- ]?friendly)\b/i, PawPrint],
  [/\b(crib|baby|high\s*chair|highchair)\b/i, Baby],
  [/\b(smoking\s*allowed|smokers?)\b/i, Cigarette],
  [/\b(sofa|couch|living\s*room)\b/i, Sofa],
];

export const getAmenityIcon = (label) => {
  if (!label) return Check;
  for (const [re, Icon] of AMENITY_ICONS) {
    if (re.test(label)) return Icon;
  }
  return Check;
};

export default getAmenityIcon;
